import { render, staticRenderFns } from "./StudentEmailPrint.vue?vue&type=template&id=36708edc&scoped=true&"
import script from "./StudentEmailPrint.vue?vue&type=script&lang=js&"
export * from "./StudentEmailPrint.vue?vue&type=script&lang=js&"
import style0 from "./StudentEmailPrint.vue?vue&type=style&index=0&id=36708edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36708edc",
  null
  
)

export default component.exports